import cx from 'classnames';

import Modal from 'components/modal';
import i18n from 'i18n/config';
import { CloseIcon } from 'styles/assets/icons';

import styles from './ChartOrderbookTab.module.scss';
import ShowBuySellButtonOnChartSwitch from './ShowBuySellButtonOnChartSwitch';
import ShowConfirmationMessageForOrderPlacedFromChart from './ShowConfirmationMessageForOrderPlacedFromChart';

const modalStyleOverrides = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
  content: {
    position: 'fixed',
    top: 'unset',
    left: '50%',
    right: 'unset',
    bottom: '0px',
    padding: '0px',
    paddingBottom: '10px',
    background: 'var(--main-bg-surface-alt)',
    boxShadow: '0 3px 20px 0 rgba(0, 0, 0, 0.16)',
    border: 'none',
    overflow: 'auto',
    borderRadius: 0,
    transform: 'translate(-50%)',
    width: '100%',
  },
};

const label = i18n.t('trading:placeOrderFromChart');

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SettingsModal = ({ isOpen, onClose }: SettingsModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      style={modalStyleOverrides}
      contentLabel={label}
      onRequestClose={onClose}
    >
      <div className={styles.wrapper}>
        <div
          className={cx(
            'flex-set flex--content-center flex--align-items-center',
            styles.settingsHeader
          )}
        >
          <h2 className="font-bold ml-auto">{label}</h2>
          <button
            type="button"
            data-testid="close-icon-settings-modal"
            onClick={onClose}
            className={cx(
              'flex-set flex--content-center flex--align-items-center naked ml-auto',
              styles.settingsCloseButton
            )}
          >
            <CloseIcon />
          </button>
        </div>
        <div className={styles.settingsContent}>
          <div className={styles.settingsContentItem}>
            <ShowBuySellButtonOnChartSwitch />
            <ShowConfirmationMessageForOrderPlacedFromChart />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SettingsModal;
